import { Menu, MenuButton, MenuItem, MenuItems } from "@headlessui/react"
import { Bars3Icon, XMarkIcon } from "@heroicons/react/24/solid"

import { Bee } from "~/src/components/BeeKit"

export type SignInProps = { signInUrl: string }

export function SignIn(props: SignInProps) {
  const { signInUrl } = props

  return (
    <>
      <div className="hidden flex-row items-center gap-6 md:flex">
        <a href={signInUrl} className="text-center text-sm">
          Sign in
        </a>
        <Bee.ButtonAnchor
          href="https://www.brilliantmade.com/request-a-demo-form"
          className="bg-magenta-500 border-none text-sm text-white"
        >
          Get started
        </Bee.ButtonAnchor>
      </div>
      <Menu as="div" className="flex md:hidden">
        <MenuButton>
          {({ open }) => (open ? <XMarkIcon className="h-6 w-6" /> : <Bars3Icon className="h-6 w-6" />)}
        </MenuButton>
        <MenuItems className="absolute right-0 mt-10 flex w-full origin-top flex-col gap-1 border-b border-gray-200 bg-white p-4 shadow-lg">
          <MenuItem>
            <Bee.ButtonAnchor
              href="https://www.brilliantmade.com/request-a-demo-form"
              className="bg-magenta-500 border-none text-white"
            >
              Get started
            </Bee.ButtonAnchor>
          </MenuItem>
          <MenuItem>
            <Bee.ButtonAnchor kind="secondary" href={signInUrl} className="border-gray-200">
              Sign in
            </Bee.ButtonAnchor>
          </MenuItem>
        </MenuItems>
      </Menu>
    </>
  )
}
